import { put, takeEvery, select, call } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { push } from "connected-react-router";
import {
  FETCH_TRIPEVENTS_INIT,
  FETCH_TRIPEVENTS_SUCCESS,
  FETCH_TRIPEVENTS_FAIL,
  FETCH_TRIPBYID_INIT,
  FETCH_TRIPBYID_SUCCESS,
  FETCH_TRIPBYID_FAIL,
  FETCH_TRIPLOG_INIT,
  FETCH_TRIPLOG_SUCCESS,
  FETCH_TRIPLOG_FAIL,
  TRIP_ADD_DOC_INIT,
  TRIP_ADD_DOC_SUCCESS,
  DELETE_DOC_INIT,
  DELETE_DOC_SUCCESS,
  DELETE_DOC_FAIL
} from "./action";
import { appConfig } from "../../config";

function* fetchTripEvents(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let userorgId = user.orgId;
  let userId = user.id;
  let filter = (value.payload && value.payload.filter) || "";
  let dateFilter = (value.payload && value.payload.dateFilter) || "";
  let filterParam = "";
  let excludeUserParam = "&excludeStatus=deleted";
  if (filter) {
    filterParam = `&status=${filter}`;
    excludeUserParam = "";
  }

  //For pagination purpose
  /*   let pageno = !value.payload
    ? 1
    : value.payload.page === undefined
    ? 1
    : value.payload.page;

 */ let pageno = !value.payload
    ? 1
    : value.payload.page === undefined
      ? 1
      : value.payload.page === 0
        ? 1
        : value.payload.page;
  let search = !value.payload
    ? ""
    : value.payload.search === undefined
      ? ""
      : value.payload.search;

  try {
    const res =
      user.role === "runner"
        ? yield fetch(
          `${appConfig.ip}/trip?userOrgId=${userorgId}&ser=${search}&limit=10&page=${pageno}${filterParam}${excludeUserParam}${dateFilter}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        : yield fetch(
          `${appConfig.ip}/trip?custmrOrgId=${userorgId}&ser=${search}&limit=10&page=${pageno}${filterParam}${excludeUserParam}${dateFilter}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_TRIPEVENTS_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_TRIPEVENTS_FAIL, error: err });
    } else {
    }
  }
}

function* fetchSpecificTripdata(value) {
  const token = localStorage.getItem("token");
  let id = value.payload;

  try {
    const res = yield fetch(`${appConfig.ip}/trip/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_TRIPBYID_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_TRIPBYID_FAIL, error: err });
    } else {
    }
  }
}

function* fetchTriplog(value) {
  const token = localStorage.getItem("token");
  const id = value.payload;

  try {
    const res = yield fetch(`${appConfig.ip}/tripLog?tripId=${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_TRIPLOG_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_TRIPLOG_FAIL, error: err });
    } else {
    }
  }
}

function* addDocument(value) {
  try {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("UserRole");
    const state = yield select()
    let tripData = state.tripEventsReducer.tripData
    let time = Math.floor(Date.now() / 1000);
    const data = new FormData();
    data.append(tripData.id + '-doc-' + time, value.value.image, tripData.id + '-doc-' + time);
    let res = yield fetch(appConfig.ip + '/trip/image', {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      let resJSON = yield res.json();

      yield put({
        type: TRIP_ADD_DOC_SUCCESS,
        payload: resJSON.fileName,
      });
      let formData = [
        {
          fileName: resJSON.fileName,
          docType: value.value.image.type,
          title: value.value.name,
          creator: role,
        },
      ];
      let data = {
        document: [...tripData.document, formData[0]],
      };
      yield call(updateTripDocs, data);
    }
    //  }
  } catch (err) {
    if (err.ok === false) {
    } else {
    }
  }

}

function* updateTripDocs(action) {
  const token = localStorage.getItem("token");
  const state = yield select()
  const tripData = state.tripEventsReducer.tripData
  try {
    let updateData = action
    let res = yield fetch(appConfig.ip + '/trip/' + tripData.id, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(updateData),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      let resJSON = yield res.json();

      yield put({
        type: FETCH_TRIPBYID_INIT,
        payload: tripData.id,
      });
    }
  } catch (err) { }
}

function* deleteDocument(action) {
  const state = yield select()
  let tripData = state.tripEventsReducer.tripData
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(appConfig.ip + '/trip/image?image=' + action.value.fileName, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      let resJSON = yield res.json();
      yield put({
        type: DELETE_DOC_SUCCESS,
        value: resJSON
      });
      if (resJSON.message === 'file deleted') {
        let documents = tripData.document.filter(data => data._id !== action.value._id)
        let data = {
          document: documents,
        };
        yield call(updateTripDocs, data);
      } else {
        yield toast.error("Failed to delete image", {
          autoClose: 3000,
          className:"toastClass"
        });
      }
    }
  } catch (err) {
    if (err.ok === true) {
      yield put({
        type: DELETE_DOC_FAIL,
        payload: err
      })
    }
  }
}


export function* TripEventsActionWatcher() {
  yield takeEvery(FETCH_TRIPEVENTS_INIT, fetchTripEvents);
  yield takeEvery(FETCH_TRIPBYID_INIT, fetchSpecificTripdata);
  yield takeEvery(FETCH_TRIPLOG_INIT, fetchTriplog);
  yield takeEvery(TRIP_ADD_DOC_INIT, addDocument)
  yield takeEvery(DELETE_DOC_INIT, deleteDocument)
}
